import { useEffect, useState } from "react";
import { DashboardData } from "../types/dashboard";
import api from "../../../../../features/auth/axiosConfig";

type Mode = "year" | "month";

interface UseDashboardDataProps {
  mode: Mode;
  year?: number;
  startDate?: string;
  endDate?: string;
}

export const useDashboardData = ({
  mode,
  year,
  startDate,
  endDate,
}: UseDashboardDataProps) => {
  const [dashboardData, setDashboardData] =
    useState<DashboardData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let params: any;

        if (mode === "year") {
          if (typeof year !== "number") return;
          params = { year };
        }

        if (mode === "month") {
          if (!startDate || !endDate) return;
          params = { start_date: startDate, end_date: endDate };
        }

        setLoading(true);
        setError(null);

        const res = await api.get("/app/pos/v2/dashboard", { params });
        setDashboardData(res.data);
      } catch (e) {
        console.error(e);
        setError("Failed to load dashboard data");
        setDashboardData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [mode, year, startDate, endDate]);

  return { dashboardData, loading, error };
};
